import { type FC } from "react";
import { resolveResourceURl } from "../../utils/url/urlResolver";
import { useTranslation } from "react-i18next";
import { siteSpecificTranslation } from "~/utils/language/translationUtils";

interface Props {
  fullAddress: string;
}

const ContactUsSidebar: FC<Props> = ({ fullAddress }) => {
  const { t } = useTranslation();
  let imgUrl = siteSpecificTranslation(t, "page.contactUs.imageUrl");
  imgUrl = resolveResourceURl(imgUrl);

  return (
    <>
      <img src={imgUrl} />
      <h2 className="my-3 headline-small">{t("contactUsPage.heading")}</h2>
      <div className={"jsp__full-address"} dangerouslySetInnerHTML={{ __html: fullAddress }} />
    </>
  );
};

export default ContactUsSidebar;
